import React from 'react';
import { useNavigate } from 'react-router-dom';

const Splash = () => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate('/lurking')}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <h1 id="glitch-title">
        s̶̢̼̭̓͝o̸̭͆̈̊m̴̩̜͚̌ĕ̸̠̫̉w̵̪̲̃̀ĥ̷̲̫́ĕ̸̢͓͖r̸̤̖̊e̵̥̎ ̷̙̘̮̽̇d̷̺̽ȅ̷̩͎͙̀̉e̶̦̰̾̾̈́p̷͕̹͐͘
      </h1>
    </div>
  );
};

export default Splash;
